import { createComponent as cc } from 'react-fela';
import { Grid } from '@material-ui/core';

const GridWrapper100 = cc(
  () => ({
    height: '100%',
    width: '100%',
  }),
  Grid,
  [
    'container',
    'xs',
    'md',
    'xl',
    'lg',
    'justify',
    'item',
    'spacing',
    'direction',
    'alignItems',
  ],
);
export default GridWrapper100;



// WEBPACK FOOTER //
// ./src/components/wrappers/GridWrapper100.js